module.exports = __webpack_public_path__ + "media/42.e6862796.mp3";